import { useContext } from 'react';
import { AlertContext } from '../../data/context/AlertContext';

/**
 * UseAlert
 * @constructor
 */
export function UseAlert() {
  return useContext(AlertContext);
}
